/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { AddExtensionFilteringModule } from './add-extension-filtering/add-extension-filtering.module';
import { DeleteExtensionFilteringModule } from './delete-extension-filtering/delete-extension-filtering.module';
import { ExtensionFilteringComponent } from './extension-filtering.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        AddExtensionFilteringModule,
        DeleteExtensionFilteringModule,
    ],
    declarations: [ExtensionFilteringComponent],
    exports: [ExtensionFilteringComponent],
})
export class ExtensionFilteringModule { }

